import { render, staticRenderFns } from "./dynamic-compose.vue?vue&type=template&id=108fbbeb&"
import script from "./dynamic-compose.vue?vue&type=script&lang=js&"
export * from "./dynamic-compose.vue?vue&type=script&lang=js&"
import style0 from "./dynamic-compose.vue?vue&type=style&index=0&id=108fbbeb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports